/* unplugin-vue-components disabled */import { render } from "./tenant-products.vue?vue&type=template&id=7f0c7785&scoped=true"
import script from "./tenant-products.vue?vue&type=script&setup=true&lang=js"
export * from "./tenant-products.vue?vue&type=script&setup=true&lang=js"

import "./tenant-products.vue?vue&type=style&index=0&id=7f0c7785&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0c7785"],['__file',"src/pages/tenants/settings/tenant-products.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f0c7785"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f0c7785', __exports__)) {
    api.reload('7f0c7785', __exports__)
  }
  
  module.hot.accept("./tenant-products.vue?vue&type=template&id=7f0c7785&scoped=true", () => {
    api.rerender('7f0c7785', render)
  })

}


export default __exports__